
import React from "react";

/** Components */
import Project from '../../components/Projects/Projects';
import CustomerWrapper from '../../components/CustomerWrapper';



export default (props) => {
  const customerId = props.match.params.id;

  return (
    <CustomerWrapper {...props}>
      <Project customerId={customerId} defaultFilter={{customerId}} />
    </CustomerWrapper>

  );

}

